let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j3vq9")).then(() => parcelRequire('9XBkh'));